module.exports = __webpack_public_path__ + "static/media/8.8688b90f.png";